// extracted by mini-css-extract-plugin
export default {"bgvideo":"notfound_bgvideo__tBvDl","first":"notfound_first__IZ5p6","second":"notfound_second__K9fZf"};